import {
	comMapping
} from "@/components/util/Function/comMapping";

export function getdata() {
	var obj = {
		searchlist: [{
				prop: "fapdm",
				label: '发票代码',
				type: "input"
			},
			{
				prop: "faphm",
				label: '发票号码',
				type: "input"
			},
			{
				prop: "weisje",
				label: '未税金额',
				type: "inputplus"
			},
			{
				prop: "shuiehj",
				label: '税额',
				type: "inputplus"
			},
			{
				prop: "dikse",
				label: '抵扣税额',
				type: "inputplus"
			},
			{
				prop: "jiashj",
				label: '价税合计',
				type: "inputplus"
			},
			{
				prop: "kaiprq",
				label: '开票日期',
				type: "date",
				valueformat: "yyyyMMdd"
			},
			{
				prop: "benqzcbs",
				label: '本期转出标识',
				type: "select",
				selectval: comMapping.$BenqzcbsMapping
			},
			{
				prop: "zhuanclx",
				label: '进项转出类型',
				type: "select",
				selectval: []
			},
			{
				prop: "zhuancse",
				label: '本期转出税额',
				type: "inputplus"
			}
		],
		searchdata: {
			fapdm: "",
			faphm: "",
			weisje: [],
			shuiehj: [],
			dikse: [],
			jiashj: [],
			kaiprq: [],
			benqzcbs: "",
			zhuanclx: "",
			zhuancse: []
		},
		headData: [{
				title: "发票代码",
				prop: "fapdm",
				width: "200",
				custom: true

			},
			{
				title: "发票号码",
				prop: "faphm",
				width: "200",
				custom: true

			},
			{
				title: "未税金额",
				prop: "weisje",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "税额",
				prop: "shuiehj",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "抵扣税额合计",
				prop: "dikse",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "价税合计",
				prop: "jiashj",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "进项税转出类型",
				prop: "zhuanclx",
				width: "200",
				custom: true
			},
			{
				title: "本期转出标识",
				prop: "benqzcbs",
				width: "200",
				custom: true
			},
			{
				title: "本期转出税额",
				prop: "zhuancse",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "合计转出税额",
				prop: "hjzhuancse",
				width: "200",
				AmountFormat: true,
				custom: true

			},
			{
				title: "操作",
				prop: "cz",
				width: "200",
				custom: true
			},
		],
		headDatasgdj: [{
				title: "发票代码",
				prop: "fapdm",
			},
			{
				title: "发票号码",
				prop: "faphm",
			},
			{
				title: "开票日期",
				prop: "kaiprq",
			},
			{
				title: "未税金额",
				prop: "weisje",
				custom: true
			},
			{
				title: "税额",
				prop: "shuie",
				custom: true
			},
			{
				title: "抵扣税额合计",
				prop: "dikse",
				width: "100",
				custom: true
			},
			{
				title: "价税合计",
				prop: "jiashj",
				custom: true
			}
		],
		tableDatasgdj: [{
			fapdm: "1",
			faphm: "1",
			kaiprq: "1",
			weisje: "1",
			shuie: "1",
			dikse: "",
			jiashj: "1"
		}],
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 0,
			paginationkey: 0
		},
		nsrsbhData: [{
			nsrsbh: "",
			nsrmc: ""
		}],
		djdata: [{
				suosq: "2012-06",
				zhuanclx: "12",
				zhuancse: "",
				dengjsm: "123",
				baoczt: "0" // 0 新纪录 1 ：编辑状态 2：保存状态
			},
			{
				suosq: "2012-06",
				zhuanclx: "12",
				zhuancse: "",
				dengjsm: "123",
				baoczt: "0"
			},
			{
				suosq: "2012-06",
				zhuanclx: "12",
				zhuancse: "",
				dengjsm: "123",
				baoczt: "0"
			}
		]
	}
	return obj
}
